import { openDB } from 'idb';
import { LoanData } from '../models/loan-comparison';

const dbPromise = openDB('loan-db', 1, {
  upgrade(db) {
    db.createObjectStore('loans', { keyPath: 'id', autoIncrement: true });
  },
});

export const saveLoan = async (loan: LoanData): Promise<void> => {
  const db = await dbPromise;
  try {
    await db.add('loans', loan);
  } catch (error) {
    console.error('Error saving loan:', error);
    throw new Error('Could not save loan.');
  }
};

export const fetchLoans = async (): Promise<LoanData[]> => {
  const db = await dbPromise;
  try {
    return await db.getAll('loans');
  } catch (error) {
    console.error('Error fetching loans:', error);
    throw new Error('Could not fetch loans.');
  }
};

export const updateLoanTitle = async (id: number, updatedData: Omit<LoanData, 'id'>): Promise<void> => {
  const db = await dbPromise;
  await db.put('loans', { id, ...updatedData });
};


export const deleteLoan = async (id: number): Promise<void> => {
  const db = await dbPromise;
  try {
    await db.delete('loans', id);
  } catch (error) {
    console.error('Error deleting loan:', error);
    throw new Error('Could not delete loan.');
  }
};
